export default {
  apiUrl(state) {
    return state.apiUrl;
  },
  config(state) {
    return state.config;
  },
  configHasBeenRead(state) {
    return state.configHasBeenRead;
  },
  memberExists(state) {
    return state.memberExists;
  },
  questions(state) {
    return state.questions;
  },
  playerLevels(state) {
    return state.playerLevels;
  },
  rankings(state) {
    return state.rankings;
  },
  playerMoments(state) {
    return state.playerMoments;
  },
  registered(state) {
    return state.registered;
  },
};
